var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SignalDiagramBox',{attrs:{"resizedKey":_vm.resizedKey,"diagram":_vm.diagram,"comparedDiagrams":_vm.selectedDiagrams,"saveSettings":false},scopedSlots:_vm._u([{key:"toolbarAfter",fn:function(ref){
var toolbarAfter = ref.toolbarAfter;
return [_c('CompareDiagramButtonDialog',{attrs:{"disabled":toolbarAfter.disabled,"diagrams":_vm.diagrams},on:{"select":_vm.onSelect}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }